module.exports = __webpack_public_path__ + "img/popup-mlbb-id-222diamond.3b99fd3.png";